import React from 'react';
import StudentRegistration from '../../components/auth/StudentRegistration';
import SEOHead from '../../components/common/SEOHead';

const RegisterPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Đăng ký tài khoản | Training Center"
        description="Tạo tài khoản học viên để tham gia các khóa học chất lượng cao tại Training Center"
        url="/register"
        type="website"
      />
      <StudentRegistration />
    </>
  );
};

export default RegisterPage;